var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "crash-history" }, [
      _c(
        "div",
        { staticClass: "history-page history-page_crash" },
        [
          _c("ui-page-header"),
          _c("div", { staticClass: "history-page__content" }, [
            _c(
              "div",
              {
                staticClass: "history-page__scroll",
                attrs: { scroll: "vertical" },
              },
              [
                _c(
                  "div",
                  { staticClass: "cdk-virtual-scroll-content-wrapper" },
                  _vm._l(_vm.list, function (item) {
                    return _c(
                      "router-link",
                      {
                        key: item.id,
                        staticClass: "crash-round link",
                        attrs: {
                          to: {
                            name: _vm.crashHistoryDetailRouteName,
                            params: { id: item.id },
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "crash-round__head" }, [
                          _c(
                            "div",
                            {
                              staticClass: "crash-round__ratio",
                              class: _vm.historyGameColor(
                                "crash-round__ratio",
                                item.crashPoint
                              ),
                            },
                            [_vm._v(" x" + _vm._s(item.crashPoint) + " ")]
                          ),
                          _c("div", { staticClass: "crash-round__players" }, [
                            _c("i", { staticClass: "icon icon_user-half" }),
                            _vm._v(" " + _vm._s(item.playerCount) + " "),
                          ]),
                        ]),
                        _c(
                          "div",
                          { staticClass: "crash-round__bank currency_USD" },
                          [_vm._v(_vm._s(item.betSum))]
                        ),
                        _c("div", { staticClass: "crash-round__footer" }, [
                          _c("div", { staticClass: "crash-round__date" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm
                                    .dayjs(item.createdAt)
                                    .format("DD/MM HH:mm")
                                ) +
                                " "
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "crash-round__id" },
                            [
                              item.id
                                ? _c("vue-ellipsis", {
                                    attrs: {
                                      "visible-line": 1,
                                      text: "#" + item.id,
                                      "ellipsis-node": "....",
                                      reflowOnResize: "",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ]
                    )
                  }),
                  1
                ),
              ]
            ),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }